import { InMemoryCache } from '@apollo/client';
import { typePolicies } from '@common/apollo';

const cache = new InMemoryCache({ typePolicies });

export default cache;
